import { useState, useRef, Fragment } from 'react';
import { SdfBusyIndicator, SdfButton } from '@waypoint/react-components';
import { useGetUserEntitlementsQuery } from '@headless-shell/store';
import { useSelector } from 'react-redux';
import { getResourcesFromAllowedKeys } from './resourcesDropdown';
import { Box } from '@mui/material';

import { UserButton, UserName, UserMenuArrow, ResourceMenuItem, ResourcesMenu, ResourceMenuDivider, ManageSection, StyledSdfButton } from './styles';
import { useTranslatedObject } from '../../utils/translation';
import { MyAppsMenuClick, sendGA4Data, HeaderUserNameClick } from '../../analytics/events';

const Resources = ({ navigate }) => {
  const isAuthenticated = useSelector((state) => !!state?.app?.isAuthenticated);
  const { userInfo = {} } = useSelector((state) => state.userContext?.userInfo || {});
  // const { company: { id: companyId = '' } = {}, user: { id: userId = '' } = {} } = appDirectInfo || {};
  const { family_name = '', given_name = '' } = userInfo || {};
  const userButtonRef = useRef(null);
  const [resourceMenuOpen, setResourceMenuOpen] = useState(false);

  const { data, isLoading } = useGetUserEntitlementsQuery(undefined, {
    skip: !isAuthenticated
  });
  const header = useTranslatedObject('header');
  const resources = getResourcesFromAllowedKeys(data?.allowedResources || [], header.resources || {});
  const showMyApps = !!header?.my_apps;


  const displayName = (family_name && given_name) ?
    `${given_name.trim().charAt(0)}. ${family_name.trim().charAt(0)}${family_name.trim().slice(1)}`
    : '';

  const handleLogoutClick = () => {
    setResourceMenuOpen(false);
    window.dispatchEvent(new CustomEvent('auth-request-logout'));
  }

  return (
    <Fragment>

      {isLoading ? (
        <div>
          <div className="flex items-center justify-center relative">
            <SdfBusyIndicator overlay="" label-aria="checking session" size="sm" />
            <SdfButton emphasis="primary" size="sm">
              {header.login}
            </SdfButton>
          </div>
        </div>
      ) : ( <Box>
      <UserButton
        ref={userButtonRef}
        onClick={() => {
          setResourceMenuOpen(!resourceMenuOpen);
          sendGA4Data(HeaderUserNameClick);
        }}
        aria-haspopup="menu"
        aria-controls={resourceMenuOpen ? 'roles-menu' : undefined}
        aria-expanded={resourceMenuOpen ? 'true' : undefined}
        endIcon={(displayName && !isLoading) ? <UserMenuArrow/> : null}
      >
        {displayName
          ? <UserName>{displayName}</UserName>
          : null}
      </UserButton>
      <ResourcesMenu
        id="roles-menu"
        anchorEl={userButtonRef.current}
        open={resourceMenuOpen}
        onClose={() => setResourceMenuOpen(false)}
      >
        {showMyApps && (
          <>
            <ResourceMenuItem
              hasMyApps={showMyApps}
              role="menuitem"
              onClick={() => {
                setResourceMenuOpen(false);
                sendGA4Data(MyAppsMenuClick);
                navigate('/myapps');
              }}>
              {header.my_apps}
            </ResourceMenuItem>
            <ResourceMenuDivider role="separator" />
          </>
        )}
        
          <ManageSection role="presentation" bold="true" hasMyApps={showMyApps}>
            {header.manage}
          </ManageSection>

          {resources?.map(({ name, url }) => {
            return (
              <ResourceMenuItem
                role="menuitem"
                key={name}
                resourceItem
                onClick={() => {
                  setResourceMenuOpen(false);
                  navigate(url);
                }}
              >
                {name}
              </ResourceMenuItem>
            )})}
        <ResourceMenuDivider role="separator" />
        <StyledSdfButton
          action="standard"
          emphasis="tertiary"
          icon="action-logout"
          iconPlacement="before"
          size="sm"
          variant="contained"
          onClick={handleLogoutClick}
          >
          {header.logout}
        </StyledSdfButton>
      </ResourcesMenu>
    </Box>
      )}
    </Fragment>
  );
};

export default Resources;